import * as Sentry from '@sentry/react';

export const init = (): void => {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    environment: import.meta.env.VITE_APP_ENV,
    tracesSampleRate: 1.0,
  });
};

export const reportError = (error: unknown): void => {
  Sentry.captureException(error);
};
